<template>
    <div class="data-center">
        <p class="alert alert-warning">提示：本页面提供的数据仅供商户作为调整经营策略参考，不作为结款与验证的准确依据</p>
        <div class="quantity-container">
            <div class="quantity-detail">
                <h2>指定日预约量</h2>
                <p class="subtitle">指定日预约量（券）：是指用户在购买时已经选择了未来某一天作为使用日期的预约券数量</p>
                <div class="item-container">
                    <div class="item">
                        <div class="item-content">
                            <div>
                                <p>明天</p>
                                <p class="quantity">{{dayNumber.tomorrow}}</p>
                            </div>
                        </div>
                        <p class="intro">指定明天使用的预约券</p>
                    </div>
                    <div class="item">
                        <div class="item-content">
                            <div>
                                <p>后天</p>
                                <p class="quantity">{{dayNumber.afterTomorrow}}</p>
                            </div>
                        </div>
                        <p class="intro">指定后天使用的预约券</p>
                    </div>
                    <div class="item">
                        <div class="item-content">
                            <div>
                                <p>未来7天</p>
                                <p class="quantity">{{dayNumber.week}}</p>
                            </div>
                        </div>
                        <p class="intro">指定未来7天使用的预约券</p>
                    </div>
                    <div class="item">
                        <div class="item-content">
                            <div>
                                <p>未来30天</p>
                                <p class="quantity">{{dayNumber.month}}</p>
                            </div>
                        </div>
                        <p class="intro">指定未来30天使用的预约券</p>
                    </div>
                </div>
            </div>
            <div class="quantity-whole">
                <h2>有效期预约量（券）</h2>
                <p class="subtitle">有效期预约量（券）：在未来的一个有效期内都可以使用的预约券数量</p>
                <div class="item-container">
                    <div class="item">
                        <div class="item-content">
                            <div>
                                <p>累计</p>
                                <p class="quantity">{{dayNumber.total | addCommas}}</p>
                            </div>
                        </div>
                        <p class="intro text-muted">未指定使用日期的有效期预约券</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="data-container">
            <h2>历史数据概览及数据趋势</h2>
            <p class="subtitle">历史数据是从过去到昨天的任何一个时间段内的数值，</p>
            <div class="form-horizontal">
                <form class="form-group">
                    <label class="col-item control-label">
                        <strong>选择时间：</strong>
                    </label>
                    <div class="col-item">
                        <v-datepicker :message="start" v-model="start" :options="timeOption"></v-datepicker>
                    </div>
                    <div class="col-item margin-top">
                        ~
                    </div>
                    <div class="col-item">
                        <v-datepicker :message="end" v-model="end" :options="timeOption"></v-datepicker>
                    </div>
                    <button class="btn btn-primary" :disabled="buttonDisable" v-on:click="getTrend()">确认</button>
                    <span style="color:red">{{intro}}</span>
                </form>
            </div>
            <div class="data-type-container">
                <div>
                    <div class="data-reason" :class="{'active': filter == 'sales' || filter == 'buyRate' }">
                        <div class="reason-item" :class="{'active': filter == 'sales'}" v-on:click="changeFilter('sales')">
                            <div>
                                <p>购买量（券）</p>
                                <p class="quantity">{{total.sales | addCommas}}</p>
                            </div>
                        </div>
                        <div class="reason-item" :class="{'active': filter == 'buyRate'}" v-on:click="changeFilter('buyRate')">
                            <div>
                                <p>购买率</p>
                                <p class="quantity">{{total.buyRate | floatToPercent}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="data-reason" :class="{'active': filter == 'consumption' || filter == 'consumptionRate'}">
                        <div class="reason-item" :class="{'active': filter == 'consumption'}" v-on:click="changeFilter('consumption')">
                            <div>
                                <p>验证量（券）</p>
                                <p class="quantity">{{total.consumption | addCommas}}</p>
                            </div>
                        </div>
                        <div class="reason-item" :class="{'active': filter == 'consumptionRate'}" v-on:click="changeFilter('consumptionRate')">
                            <div>
                                <p>验证率</p>
                                <p class="quantity">{{total.consumptionRate | floatToPercent}}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="data-reason" :class="{'active': filter == 'refund' || filter == 'refundRate'}">
                        <div class="reason-item" :class="{'active': filter == 'refund'}" v-on:click="changeFilter('refund')">
                            <div>
                                <p>退款量（券）</p>
                                <p class="quantity">{{total.refund | addCommas}}</p>
                            </div>
                        </div>
                        <div class="reason-item" :class="{'active': filter == 'refundRate'}" v-on:click="changeFilter('refundRate')">
                            <div>
                                <p>退款率</p>
                                <p class="quantity">{{total.refundRate | floatToPercent}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="data-reason" :class="{'active': filter == 'pv' || filter == 'uv'}">
                        <div class="reason-item" :class="{'active': filter == 'pv'}" v-on:click="changeFilter('pv')">
                            <div>
                                <p>浏览量</p>
                                <p class="quantity">{{total.pv | addCommas}}</p>
                            </div>
                        </div>
                        <div class="reason-item" :class="{'active': filter == 'uv'}" v-on:click="changeFilter('uv')">
                            <div>
                                <p>访客量</p>
                                <p class="quantity">{{total.uv | addCommas}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <p class="showIntro" v-on:click="show=true">
                <a>点此查看各数据指标定义</a>
            </p>
            <ul class="list-unstyled intros" v-if="show">
                <li>购买量（券）：旅游券的销售数量（非金额），反映了产品的整体售卖情况</li>
                <li>访购率：项目的购买人次/访客量，反映了项目的对消费者的吸引力</li>
                <li>验证量（券）：旅游券的验证数量（非金额），反映了项目的实际接待和收入情况</li>
                <li>验证率：项目的验证券数量/购买券数量，反映了项目的最终消费情况</li>
                <li>退款量（券）：旅游券的发生退款的数量（非金额）</li>
                <li>退款率：项目的退款量（券）/销售量（券）</li>
                <li>浏览量：项目页面的浏览次数，反映了项目的曝光程度</li>
                <li>访客量：项目页面的浏览用户数，反映了项目的曝光人数</li>
            </ul>

            <div id="charts" class="charts">

            </div>
            <p class="text-muted">备注：选中相应的数据指标即可查看其数据趋势</p>
        </div>
    </div>
    </div>
</template>
<style lang="postcss">
.data-center {
    padding: 20px;
    .alert {
        padding: 10px;
        margin-bottom: 20px;
        border: 1px solid transparent;
        border-radius: 0;
        font-size: 14px;
    }
    .alert-warning {
        background-color: #fff7e5;
        border-color: #ffd98c;
        color: #666;
    }
    .subtitle {
        height: 3em;
        color: #777;
    }
    .quantity-container {
        overflow: hidden;
        display: flex;
        border: 1px solid #ccc;
        border-radius: 4px;
        padding: 20px;
        .quantity-detail {
            flex: 4;
            padding-right: 10px;
        }
        .item-container {
            display: flex;
            .item {
                flex: 1;
                margin-right: 10px;
                .item-content {
                    border: 1px solid #ccc;
                    height: 130px;
                    text-align: center;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    p {
                        margin: 0;
                    }
                    .quantity {
                        font-size: 26px;
                    }
                }
                .intro {
                    margin-top: 20px;
                    color: #777;
                }
            }
        }
        .quantity-whole {
            padding-left: 20px;
            flex: 1.8;
            border-left: 1px solid #ccc;
        }
    }
    .data-container {
        border: 1px solid #ccc;
        border-radius: 4px;
        margin-top: 30px;
        padding: 20px;
        .form-horizontal {
            .col-item {
                position: relative;
                min-height: 1px;
                padding-left: 15px;
                padding-right: 15px;
                display: inline-block;
                float: left;
            }
            .control-label {
                text-align: right;
                margin-bottom: 0;
                padding-top: 10px;
            }
        }
        .data-type-container>div {
            display: flex;
            margin-top: 20px;
            .data-reason {
                cursor: pointer;
                display: flex;
                margin-right: 20px;
                .active {
                    background: #ff9200;
                    color: #fff;
                }
                .activeButton {
                    background: #3dc6b6;
                    color: #fff;
                }
                .reason-item {
                    display: flex;
                    height: 80px;
                    width: 150px;
                    border: 1px solid #ccc;
                    align-items: center;
                    justify-content: center;
                    text-align: center;
                    .quantity {
                        font-size: 26px;
                    }
                    p {
                        margin: 0;
                    }
                }
            }
            .data-reason.active .reason-item {
                border-color: #ff9200;
            }
        }
        .intros {
            line-height: 2;
        }
        .showIntro {
            margin-top: 20px;
        }
        .text-muted {
            color: #777;
        }
        .charts {
            height: 240px;
        }
    }
}
</style>
<script>
import { getReserveData, getHistoryData } from 'api/dataCenter.js';
import { formatDate as formdate } from 'helpers/formatDate.js';
import toPercent from 'filters/toPercent.js'
export default {
    data() {
        return {
            start: this.getFormateDate(new Date((new Date().valueOf() - 7 * 24 * 60 * 60 * 1000))),
            end: this.getFormateDate(new Date((new Date().valueOf()-1 * 24 * 60 * 60 * 1000))),
            filter: 'sales',
            show: false,
            chartData: [],
            dayNumber: {
                tomorrow: 0,
                afterTomorrow: 0,
                total: 0,
                month: 0,
                week: 0
            },
            buttonDisable: false,
            intro: '',
            legendName: {
                'sales': '购买量（券）',
                'buyRate': '购买率',
                'consumption': '验证量（券)',
                'consumptionRate': '验证率',
                'refund': '退款量（券）',
                'refundRate': '退款率',
                'pv': '浏览量',
                'uv': '访客量'
            },
            total: {
                buyRate: 0.0,
                consumption: 0,
                consumptionRate: 0,
                pv: 0,
                refund: 0,
                refundRate: 0,
                sales: 0,
                uv: 0
            },
            timeOption: {
                //maxDate: new Date((new Date().valueOf() - 24 * 60 * 60 * 1000)),
                //minDate: new Date((new Date().valueOf() - 90 * 24 * 60 * 60 * 1000)),
                onChange: (date) => {
                    this.$nextTick(
                        I => {
                            if (this.start && this.end) {
                                if (this.end > this.getFormateDate(new Date((new Date().valueOf() - 24 * 60 * 60 * 1000)))) {
                                    this.intro = "结束时间应选在昨天之前";
                                }
                                else if (this.start > this.end) {
                                    this.intro = "结束时间应大于开始时间";
                                }
                                else if (this.getFormateDate(new Date((new Date(this.end).valueOf() - 90 * 24 * 60 * 60 * 1000))) > this.start) {
                                    this.intro = "开始与结束时间间隔需小于90天";
                                }
                                else if (this.start < this.getFormateDate(new Date((new Date().valueOf() - 90 * 24 * 60 * 60 * 1000))) || this.end < this.getFormateDate(new Date((new Date().valueOf() - 90 * 24 * 60 * 60 * 1000)))) {
                                    this.intro = "请选择最近3个月内数据";
                                }
                                else {
                                    this.intro = "";
                                    this.buttonDisable = false;
                                }
                                if (this.intro) {
                                    this.buttonDisable = true;
                                }
                            }
                        }
                    )
                }
            },
            options: {
                tooltip: {
                    show: true
                },
                legend: {
                    data: ['购买量（券）']  // 数据属性
                },
                xAxis: [{
                    type: 'category',
                    boundaryGap: false,
                    data: [], // X坐标内容
                    color: '#000',
                    axisLine: {
                        lineStyle: {
                            color: '#000'
                        }
                    }
                }],
                yAxis: [{
                    type: 'value',
                    axisLine: {
                        lineStyle: {
                            color: '#000'
                        }
                    },
                    axisLabel: {
                    }
                }],
                series: [{
                    'name': '购买量（券）',
                    'type': 'line',
                    'data': [],
                    'symbolSize': 4,
                    'symbol': 'emptyCircle'
                }],
                itemStyle: {
                    width: 2,
                    emphasis: {
                        borderWidth: 2,
                        borderColor: '#000'
                    },
                    normal: {
                        areaStyle: {
                            color: '#ff9200'
                        }
                    }
                }
            }
        }
    },
    created: function() {
        this.getReserveData();
        this.getHistoryData();
    },
    filters:{},
    methods: {
        alert(message) {
            this.$alert({
                title: '提示',
                message: message,
                showCancelButton: false,
                closeOnClickModal: false
            });
        },
        getFormateDate(date) {
            return this.formdate(date, 'yyyy-MM-dd');
        },
        formdate(time) {
            var date = new Date(time);
            return formdate(date, 'yyyy-MM-dd')
        },
        toPercent(value) {
            return toPercent(value);
        },
        getHistoryData() {
            getHistoryData({
                start: this.start,
                end: this.end,
            }).then((response) => {
                if (response.status === 0 && response.data) {
                    this.total = response.data.total;
                    this.chartData = response.data.list;
                    let arr = this.formatData(this.chartData);
                    this.options.xAxis[0].data = arr.xAxisData;
                    this.options.series[0].data = arr.seriesData[this.filter];
                    this.charts.setOption(this.options);
                }
            }).catch((error) => {
                this.alert(error);
            })
        },
        getReserveData() {
            getReserveData().then((response) => {
                if (response && response.data) {
                    this.dayNumber = response.data;
                }
            }).catch((error) => {
                this.alert(error);
            });
        },
        changeFilter(filter) {
            this.filter = filter;
            if (filter === 'buyRate' || filter === 'refundRate' || filter === 'consumptionRate') {
                this.options.yAxis[0].axisLabel.formatter = '{value} %';
            } else {
                this.options.yAxis[0].axisLabel.formatter = '{value}';
            }
            this.options.series[0].data = this.formatData(this.chartData).seriesData[filter];
            console.log(this.options.series[0].data)
            this.options.legend.data[0] = this.options.series[0].name = this.legendName[filter];
            this.charts.setOption(this.options);
        },
        getTrend() {
            this.getReserveData();
            this.getHistoryData();
        },
        drawPolyLine(id) {
            this.charts = echarts.init(document.getElementById(id));
            this.charts.setOption(this.options);
        },
        formatData(data) {
            if (!data || !Array.isArray(data)) {
                return;
            }
            let i;
            let l;
            // data 数据源；  type 展示属性； opt 图标配置项
            var xAxisData = [];
            var seriesData = {};
            for (i = 0, l = data.length; i < l; i++) {
                xAxisData.push(data[i].date);
                let item = data[i];
                let _this = this;
                Object.keys(item).forEach(function(key) {
                    let val = item[key];
                    if (!seriesData[key]) {
                        seriesData[key] = [];
                    }
                    if (key === 'buyRate' || key === 'refundRate' || key === 'consumptionRate') {
                        if (val) {
                            val = _this.toPercent(val);
                            console.log(val)
                        }
                        else {
                            val = 0;
                        }
                    }
                    seriesData[key].push(val);
                });
            }
            return {
                xAxisData: xAxisData,
                seriesData: seriesData
            };
        }

    },
    mounted() {
        this.$nextTick(function() {
            this.drawPolyLine('charts');
        })
    }

}
</script>



// WEBPACK FOOTER //
// operationData.vue?272e6db8